export const helpLink = "ztzW7d";
export default {helpLink};